export default "__VITE_ASSET__Jyb0BI9F__"